import moment from 'moment';

export const isFutureDate = (date?: string | null): boolean =>
    Boolean(date) && moment(date).isAfter(moment());
